namespace $ {

	export function $mol_fail_hidden( error : any ) : never {
		throw error /// Use 'Never Pause Here' breakpoint in DevTools or simply blackbox this script
	}

}
